import { T } from '@/lib/theme'
import { Tooltip, HelpIcon } from '@/components/ui'

/// The two-column key/value block both detail pages use for reserve and loop parameters.
///
/// Two columns rather than one, matching the reference: these are read in PAIRS (collateral factor
/// against liquidation threshold, supplied against borrowed), and a single tall column separates
/// the two halves of every comparison by the height of the list. Collapses to one column under
/// 560px, where side-by-side would wrap mid-value.
///
/// `items`: `[{ label, value, help, color, mono }]`. A null entry is dropped, so callers can use a
/// plain conditional in the array instead of building it imperatively.
export function StatGrid({ items, columns = 2, style = {} }) {
  const visible = items.filter(Boolean)
  if (visible.length === 0) return null
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fit, minmax(240px, 1fr))`,
        columnGap: 32,
        ...style,
      }}
      data-columns={columns}
    >
      {visible.map((it) => (
        <div key={it.label} style={row}>
          <span style={labelStyle}>
            {it.label}
            {it.help && (
              <Tooltip content={<div style={tipStyle}>{it.help}</div>}>
                <HelpIcon text={it.help} nativeTitle={false} />
              </Tooltip>
            )}
          </span>
          <span className={it.mono === false ? undefined : 'mono'} style={{ ...valueStyle, color: it.color ?? T.text }}>
            {it.value}
          </span>
        </div>
      ))}
    </div>
  )
}

const row = {
  display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 16,
  padding: '11px 0', borderBottom: `1px solid ${T.border}`,
}
const labelStyle = {
  display: 'inline-flex', alignItems: 'center', gap: 5,
  color: T.textMuted, fontFamily: T.fontM, fontSize: T.fs.body,
}
const valueStyle = {
  fontFamily: T.fontN, fontSize: T.fs.body, fontWeight: 700, textAlign: 'right',
}
const tipStyle = {
  maxWidth: 260, color: T.textMuted, fontFamily: T.fontM, fontSize: T.fs.caption,
  lineHeight: 1.5, whiteSpace: 'normal',
}
